export default __webpack_public_path__ + "static/media/cornering.d82cfeb7.svg";